"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classcat_1 = require("classcat");
var theme = require("../../theme.scss");
var StyleButton = /** @class */ (function (_super) {
    tslib_1.__extends(StyleButton, _super);
    function StyleButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onToggle = function (e) {
            var _a = _this.props, onToggle = _a.onToggle, style = _a.style;
            e.preventDefault();
            onToggle(style);
        };
        return _this;
    }
    StyleButton.prototype.render = function () {
        var _a;
        var _b = this.props, label = _b.label, active = _b.active;
        return (React.createElement("span", { className: classcat_1.default([theme.editorStyleButton, (_a = {}, _a[theme.editorActiveButton] = active, _a)]), onMouseDown: this.onToggle }, label));
    };
    return StyleButton;
}(React.Component));
exports.default = StyleButton;
